import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicMediaWithProducts {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        perPage: 1,
        gap: '0.5rem',
        center: true,
        arrows: false,
        pagination: true,
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.sm]: {
            arrows: true,
          },
        },
      },
      true,
    );
  }
}
